// Copy for the session states (verifying, connection problem, connection
// banner, application error). Same `{ en, ar }` shape as the other feature
// translation files; pick with `sessionTranslations[language]`.
const sessionTranslations = {
  en: {
    // Verifying (identity not confirmed yet)
    verifyingTitle: "Verifying your account…",
    verifyingSlow: "Still connecting to Nexploy — this is taking longer than usual.",

    // Connection problem (startup — identity not confirmed)
    offlineTitle: "You're offline",
    offlineBody:
      "Nexploy can't verify your account because this device isn't connected to the internet.",
    unavailableTitle: "Can't connect to Nexploy",
    unavailableBody:
      "We couldn't verify your account because the Nexploy server isn't responding right now.",
    serverErrorTitle: "Nexploy is having a problem",
    serverErrorBody:
      "Something went wrong on our side while verifying your account. Please try again shortly.",
    sessionKept:
      "You haven't been signed out — your session is still active on this device.",
    retryingIn: (seconds) => `Retrying automatically in ${seconds}s`,
    checking: "Checking connection…",
    retry: "Try again",
    signOut: "Sign out",
    signingOut: "Signing out…",
    reference: "Reference",

    // Connection banner (identity already confirmed)
    bannerOffline: "You're offline. Some information may be out of date.",
    bannerUnavailable: "Connection to Nexploy lost. Some information may be out of date.",
    bannerReconnecting: "Reconnecting…",
    bannerRetryIn: (seconds) => `Retrying in ${seconds}s`,
    bannerRetryNow: "Retry now",

    // Application error (React render crash)
    crashTitle: "Something went wrong",
    crashBody:
      "This page ran into a problem and couldn't be displayed. Your session is safe — reload the page to continue.",
    reload: "Reload page",
    goHome: "Go to home",
    errorReference: "Error reference",
  },
  ar: {
    verifyingTitle: "جارٍ التحقق من حسابك…",
    verifyingSlow: "لا يزال الاتصال بـ Nexploy جاريًا — يستغرق الأمر وقتًا أطول من المعتاد.",

    offlineTitle: "أنت غير متصل بالإنترنت",
    offlineBody: "لا يمكن لـ Nexploy التحقق من حسابك لأن هذا الجهاز غير متصل بالإنترنت.",
    unavailableTitle: "تعذّر الاتصال بـ Nexploy",
    unavailableBody: "لم نتمكن من التحقق من حسابك لأن خادم Nexploy لا يستجيب حاليًا.",
    serverErrorTitle: "يواجه Nexploy مشكلة حاليًا",
    serverErrorBody: "حدث خطأ من جهتنا أثناء التحقق من حسابك. يرجى المحاولة مرة أخرى بعد قليل.",
    sessionKept: "لم يتم تسجيل خروجك — ما زالت جلستك نشطة على هذا الجهاز.",
    retryingIn: (seconds) => `إعادة المحاولة تلقائيًا خلال ${seconds} ث`,
    checking: "جارٍ التحقق من الاتصال…",
    retry: "حاول مرة أخرى",
    signOut: "تسجيل الخروج",
    signingOut: "جارٍ تسجيل الخروج…",
    reference: "الرقم المرجعي",

    bannerOffline: "أنت غير متصل بالإنترنت. قد تكون بعض البيانات غير محدّثة.",
    bannerUnavailable: "انقطع الاتصال بـ Nexploy. قد تكون بعض البيانات غير محدّثة.",
    bannerReconnecting: "جارٍ إعادة الاتصال…",
    bannerRetryIn: (seconds) => `إعادة المحاولة خلال ${seconds} ث`,
    bannerRetryNow: "أعد المحاولة الآن",

    crashTitle: "حدث خطأ غير متوقع",
    crashBody: "واجهت هذه الصفحة مشكلة ولم يمكن عرضها. جلستك آمنة — أعد تحميل الصفحة للمتابعة.",
    reload: "إعادة تحميل الصفحة",
    goHome: "الذهاب إلى الصفحة الرئيسية",
    errorReference: "مرجع الخطأ",
  },
};

export default sessionTranslations;
